import React, { useState } from 'react';
import { TimelineItem } from '../types';
import { useUser } from '../contexts/UserContext';
import TimelineEditor from './TimelineEditor';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import EditIcon from '@mui/icons-material/Edit';

interface WhatsNextSectionProps {
  timeline: TimelineItem[];
  clientId: string;
  onUpdate: (updatedTimeline: TimelineItem[]) => void;
}

const WhatsNextSection: React.FC<WhatsNextSectionProps> = ({ 
  timeline, 
  clientId, 
  onUpdate 
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const { user } = useUser();

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleEditorClose = () => {
    setIsEditing(false);
  };

  const handleEditorSave = (updatedTimeline: TimelineItem[]) => {
    onUpdate(updatedTimeline);
    setIsEditing(false);
  };

  // Add null check to prevent runtime errors
  const safeTimeline = timeline || [];

  return (
    <>
      <section className="mb-16" id="whats-next">
        <div className="flex items-center gap-3 mb-8">
          <DoubleArrowIcon className="text-gray-900" style={{ fontSize: 28 }} />
          <h2 className="text-[32px] font-bold text-gray-900 m-0">
            What's Next
          </h2>
          {user?.canEdit ? <div style={{ display: 'flex', gap: '4px', marginLeft: 'auto' }}>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleEditClick();
              }}
              style={{
                background: 'transparent',
                color: '#3b82f6',
                border: '1px solid #bfdbfe',
                borderRadius: 8,
                padding: '8px 12px',
                cursor: 'pointer',
                fontSize: 12,
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = '#eff6ff';
                e.currentTarget.style.borderColor = '#3b82f6';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.borderColor = '#bfdbfe';
              }}
            >
              <EditIcon style={{ fontSize: 14 }} />
              Edit
            </button>
          </div> : null}
        </div>
        <div className="mb-10">
          {safeTimeline.length > 0 ? (
            <div className="relative pl-6">
              {/* Línea vertical continua con gradiente que se desvanece */}
              <div 
                className="absolute left-1.5 top-1.5 bottom-0 w-px"
                style={{
                  background: 'linear-gradient(to bottom, #000000 0%, #000000 70%, transparent 100%)'
                }}
              ></div>
              
              {safeTimeline.map((item, index) => (
                <div key={item.id} className={`relative ${index < safeTimeline.length - 1 ? 'mb-8' : ''}`}>
                  {/* Punto posicionado sobre la línea */}
                  <div className="absolute -left-6 top-1.5 w-3 h-3 bg-black rounded-full z-10"></div>
                  
                  {/* Contenido del timeline */}
                  <div>
                    <div className="font-bold text-gray-900 text-[18px] mb-2">
                      {item.emoji} {item.date} — {item.title}
                    </div>
                    <div className="text-gray-700 text-[18px] leading-relaxed">
                      {item.description}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-10 text-gray-500 text-[18px] italic">
              No upcoming timeline items yet.
            </div>
          )}
        </div>
      </section>
      
      <TimelineEditor
        isOpen={isEditing}
        onClose={handleEditorClose}
        clientId={clientId}
        initialTimeline={safeTimeline}
        onSave={handleEditorSave}
      />
    </>
  );
};

export default WhatsNextSection; 